<template>
  <div class="m">
    <!-- <NavBar /> -->
    <GoBack :title="data.title" />
    <div class="m-main">
      <!-- <h4 class="page-header">{{ data.title }}</h4> -->
      <div class="author">
        <span>{{ data.author }}</span>
        <span>{{ parseTime(data.publishDate ) }}</span>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="content" v-html="data.content" />
    </div>
    <div v-if="data.toSurveyKey" class="bottom-btn">
      <van-button
        type="primary"
        :disabled="hasSubmit"
        @click="clickBtn"
      >{{ hasSubmit? $t('mobile.applied') : $t('mobile.goApply') }}</van-button>
    </div>
  </div>
</template>
<script>
import { Button } from 'vant'
import { http } from '@/api'
import { setSurveyRedirectUrl, removeSurveyRedirectUrl } from '@/util/auth'
import { getLocal } from '@/util/local'
import { PublicMiniSite } from '@/api/collection'
import { parseTime } from '@/util/date'
// import NavBar from './NavBar'
import GoBack from './GoBack'
export default {
  name: 'ArticleDetail',
  components: {
    // NavBar,
    GoBack,
    [Button.name]: Button
  },
  data() {
    return {
      data: {},
      surveyKey: ''
    }
  },
  computed: {
    hasSubmit() {
      if (this.surveyKey) {
        return getLocal(this.surveyKey).includes(this.$route.query.id)
      } else {
        return false
      }
    }
  },
  mounted() {
    removeSurveyRedirectUrl()
    this.GetArticleById({ id: this.$route.query.id })
  },
  methods: {
    async GetArticleById(data) {
      const res = await http({
        path: PublicMiniSite.GetArticleById.path,
        method: PublicMiniSite.GetArticleById.method,
        data
      })

      if (res.resultCode === '0') {
        this.data = res.data
        this.surveyKey = res.data.toSurveyKey
      }
    },
    parseTime,
    clickBtn() {
      setSurveyRedirectUrl(this.$route.fullPath)
      const params = window.btoa(encodeURI(this.data.title))
      const url = '/survey-new?surveyKey=' + this.surveyKey + '&id=' + this.$route.query.id + '&params=' + params
      this.$router.push({ path: url })
    }
  }
}
</script>
